import React from 'react'
import PropTypes from 'prop-types'
import { useViewport } from '../utils';
import colors from '../utils/colors';

// const COLORS = [colors.green, '#52BAE2', '#FF5448', '#7171EF', '#FFC020', '#753A00'];
const COLORS = colors.organization_backgrounds;

const ColorSelect = ({ defaultValue, onChange }) => {
  const [selected, setSelected] = React.useState(COLORS[0])
  const { isMobile } = useViewport()

  React.useEffect(() => {
    if(defaultValue){
      setSelected(defaultValue)
    }
  }, [defaultValue])

  const style = {
    width: isMobile ? '14px' : '20px',
    height: isMobile ? '14px' : '20px',
  }

  const handleSelect = (e) => {
    setSelected(e)
    if(typeof onChange === 'function'){
      onChange(e)
    }
  }

  return (
    <div className="flex flex-wrap">
      {
        COLORS.map((c, index) => (
          <div
            key={index}
            className={`bg-white rounded-full border mb-3 mr-3 lg:mr-5 cursor-pointer`}
            style={{borderColor: c === selected ? c : '#fff'}}
            onClick={() => handleSelect(c)}
          >
            <div
              key={index}
              style={{
                backgroundColor: c,
                ...style
              }}
              className="rounded-full m-1"
            />
          </div>
        ))
      }
    </div>
  )
}

ColorSelect.propTypes = {
  defaultValue: PropTypes.string,
  onChange: PropTypes.func
}

ColorSelect.defaultProps = {
  defaultValue: COLORS[0],
  onChange: () => {},
}

export { ColorSelect }
